import "./TravelGuides.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Archive from "./sections/Archive";
import Footer from "@/reusable_sections/Footer";
export default function TravelGuidesPage() {
  return <div>
      <Header />
      <Hero />
      <Archive />
      <Footer />
    </div>;
}